import * as yup from 'yup';


import * as customerConstants from '../customerConstants';
import {addressFormConstants} from '../../Address/AddressForm';
import {billingDataFormConstants} from '../../Billing/BillingDataForm';



// ------ name
export const CUSTOMER_NAME_LENGTH_MAX = 50;
export const CUSTOMER_NAME_LENGTH_MIN = 2;


// ------ schema fields
export const SCHEMA_CUSTOMER_INTEREST = yup.string()
    .nullable()
    .oneOf(customerConstants.CUSTOMER_INTERESTS);

export const SCHEMA_CUSTOMER_NAME = yup.string()
    .nullable()
    .min(CUSTOMER_NAME_LENGTH_MIN)
    .max(CUSTOMER_NAME_LENGTH_MAX)
    .strictText();



// ------ customer form schema
export const SCHEMA_CUSTOMER_FORM = yup.object()
    .shape({
        address: addressFormConstants.SCHEMA_ADDRESS.required(),
        billingData: billingDataFormConstants.SCHEMA_BILLING_DATA.required(),
        interest: SCHEMA_CUSTOMER_INTEREST.required(),
        name: SCHEMA_CUSTOMER_NAME.required()
    });
